import { HubConnectionBuilder } from '@microsoft/signalr';
export const signalrConnectionBuilder = new HubConnectionBuilder(); // .withHubProtocol(new MessagePackHubProtocol())
